import moment from 'moment'
import { mapState } from 'vuex'
const uuidv1 = require('uuid/v1')

export default {
  props: {
    boardId: { type: String, required: true },
    seq: { type: [String, Number], default: '' }
  },
  data () {
    return {
      row: {
        userName: '',
        boardPassword: '',
        title: '',
        content: '',
        answer: '',
        files: [],
        thumbnails: [],
        tags: '',
        filter: '',
        uuid: '',
        etc: {},
        secretFlag: 'N',
        noticeFlag: 'N',
        useFlag: 'N'
      },
      origin: {},
      error: {},
      uploadStatus: '',
      stringifyComponents: '',
      dlg: {
        type: '',
        isOpen: false,
        isError: false,
        boardPassword: ''
      }
    }
  },
  computed: {
    ...mapState(['user']),
    hasEditRole () {
      // if (this.user && (this.user.role === 'master' || this.user.role === 'head-master')) {
      //   return true
      // }
      if (this.row.userId) {
        if (this.row.userId !== this.user.userId) {
          return false
        }
      } else {
        if (this.user && this.user.userId) {
          return false
        }
      }
      return true
    },
    answerFlag () {
      return this.boardMeta.useOptions.hasOwnProperty('answerFlag') && this.boardMeta.useOptions.answerFlag === 'Y'
      // },
      // viewContent () {
      //   return this.row.content
    }
  },
  watch: {
    // viewContent () {
    //   this.$nextTick(function () {
    //     var videos = document.querySelectorAll('.ql-video')
    //     for (let i = 0; i < videos.length; i++) {
    //       var embedContainer = document.createElement('div')
    //       embedContainer.setAttribute('class', 'embed-container')
    //       var parent = videos[i].parentNode
    //       parent.insertBefore(embedContainer, videos[i])
    //       embedContainer.appendChild(videos[i])
    //     }
    //   })
    // }
  },
  async created () {
    if (this.boardMeta.etcMeta && this.boardMeta.etcMeta.length > 0) {
      this.boardMeta.etcMeta.map(etc => {
        this.row.etc[etc.fieldId] = ''
      })
    }

    const { seq } = this.$route.params
    if (seq) {
      await this.init()
    } else {
      this.row.createdAt = new Date()
      this.row.uuid = `${moment().format('YYYYMMDD')}_${uuidv1()}`

      const { useFlag } = this.boardMeta.fieldMetaMap
      this.row.useFlag = (useFlag && useFlag.default) || 'Y'

      const { secretFlag } = this.boardMeta.fieldMetaMap
      this.row.secretFlag = (secretFlag && secretFlag.default) || 'Y'
    }
  },
  methods: {
    isHtml (field) {
      const { isHtml = true } = this.boardMeta.fieldMetaMap[field]
      return isHtml
    },
    async init () {
      try {
        const query = this.dlg.boardPassword ? `?boardPassword=${this.dlg.boardPassword}` : ''
        await this.$load(`/api/boards/${this.boardId}/seqs/${this.seq}${query}`)
        this.stringifyComponents = JSON.stringify(this.row.components, null, 2)
        // this.$nextTick(function () {
        //   var videos = document.querySelectorAll('.ql-video')
        //   for (let i = 0; i < videos.length; i++) {
        //     var embedContainer = document.createElement('div')
        //     embedContainer.setAttribute('class', 'embed-container')
        //     var parent = videos[i].parentNode
        //     parent.insertBefore(embedContainer, videos[i])
        //     embedContainer.appendChild(videos[i])
        //   }
        // })
      } catch (ex) {
        if (ex.response.status === 403) {
          this.dlg.isOpen = true
          this.dlg.isError = !!this.dlg.boardPassword
        }
      }
    },
    async submit () {
      console.log('submit')
      // if (this.row.components && JSON.stringify(this.row.components) !== this.stringifyComponents) {
      //   this.row.components = JSON.parse(this.stringifyComponents)
      // }
      // this.$emit('submit')
      try {
        if (this.isCreateMode) {
          await this.$create(`/api/boards/${this.boardId}`)
          this.goList()
        } else if (this.isEditMode) {
          let ret = await this.$update(`/api/boards/${this.boardId}/seqs/${this.seq}`)
          if (!ret) {
            return
          }
          ret = confirm('수정되었습니다. 목록으로 이동하시겠습니까?')
          if (ret) {
            this.goList()
          }
        } else {
          let ret = await this.$update(`/api/boards/${this.boardId}/seqs/${this.seq}/answer`)
          if (!ret) {
            return
          }
          ret = confirm('답변이 작성되었습니다. 목록으로 이동하시겠습니까?')
          if (ret) {
            this.goList()
          }
        }
      } catch (error) {
        this.error = error
      }
    },
    isRemove ({ row }) {},
    async remove ({ boardPassword }) {
      if (this.user.level >= this.$utils.getLevel('master1')) {
        try {
          const ret = await this.$remove(`/api/boards/${this.boardId}/seqs/${this.row.seq}`)
          ret && this.goList()
        } catch (ex) {}
      }

      if (this.row.userId) {
        if (this.row.userId !== this.user.userId) {
          return false
        }
      } else {
        if (this.user.userId) {
          return false
        }

        if (!boardPassword) {
          this.dlg.type = 'remove'
          this.dlg.boardPassword = ''
          this.dlg.isOpen = true
          this.dlg.isError = false
        } else {
          try {
            const query = boardPassword ? `?boardPassword=${boardPassword}` : ''
            await this.$http.delete(`/api/boards/${this.boardId}/seqs/${this.row.seq}${query}`)
            this.goList()
          } catch (ex) {
            console.log(ex)
            alert('잘못된 비밀번호거나 시스템에 문제가 발생하였습니다. 관리자에게 문의해 주세요')
          }
        }
      }
    },
    goCreate () {
      this.$router.push({ name: this.isAdminMode ? 'adminBoardCreate' : 'boardCreate' })
    },
    goEdit () {
      this.$router.push({ name: this.isAdminMode ? 'adminBoardEdit' : 'boardEdit' })
    },
    goAnswer () {
      this.$router.push({ name: this.isAdminMode ? 'adminBoardAnswer' : 'boardAnswer' })
    },
    goList () {
      this.$router.push({ name: this.isAdminMode ? 'adminBoardList' : 'boardList' })
    },
    async onClosedDlg (boardPassword) {
      const type = this.dlg.type

      this.dlg.isOpen = false
      this.dlg.type = ''
      this.dlg.boardPassword = ''
      if (boardPassword) {
        this.dlg.boardPassword = boardPassword
        if (type === 'remove') {
          await this.remove({ boardPassword })
        } else {
          await this.init()
        }
      } else {
        this.$router.push({ name: this.isAdminMode ? 'adminBoardList' : 'boardList' })
      }
    },
    removeFile (idx) {
      this.row.files = this.row.files.filter((file, index) => index !== idx)
    },
    removeThumbnail (idx) {
      this.row.thumbnails = this.row.thumbnails.filter((file, index) => index !== idx)
    },
    onFileError (err) {
      console.log('err', err)
      this.error = err
    },
    onFileUpload (uploadStatus) {
      this.uploadStatus = uploadStatus
    }
  },
  components: {
    BoardPasswordDlg: () => import('../BoardPasswordDlg')
  }
}
